import API from '@/lib/API.js'
import comun from './comun.js'
const nomenclador = {
  namespaced: true,
  state: {
    Lista: [],
    Seleccionado: undefined,
  },
  mutations: {
    init(state) {
      state.Seleccionado = undefined
  },
    set(state, payload) {
      state.Lista = payload;
    }
  },
  actions: {
    async set({
      commit,
      state
    }) {
      if (state.Lista.length === 0) {
        commit("comun/cargando")
        let data = await API.Nomenclador.traerTodos();
        commit("set", data)
        commit("comun/fincarga")
      }
    },
  },
  modules: {
    comun,
  }

}
export default nomenclador;